/**
 * guestCartUtils.js
 * Manages the guest cart in localStorage.
 * Cart shape: [{ productId, product: {...}, size, quantity }]
 */

const GUEST_CART_KEY = "guestCart";

export const getGuestCart = () => {
    try {
        const raw = localStorage.getItem(GUEST_CART_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
};

export const saveGuestCart = (items) => {
    localStorage.setItem(GUEST_CART_KEY, JSON.stringify(items));
    // Notify same-tab listeners (window.storage only fires for OTHER tabs)
    window.dispatchEvent(new Event("guestCartUpdated"));
};

export const addToGuestCart = (product, size, quantity = 1) => {
    if (!product || !product._id) {
        console.error("addToGuestCart: invalid product", product);
        throw new Error("Product data missing — cannot add to cart");
    }
    const cart = getGuestCart();
    const existingIdx = cart.findIndex(
        (i) => i.productId === product._id && i.size === size
    );

    if (existingIdx >= 0) {
        cart[existingIdx].quantity += quantity;
    } else {
        cart.push({
            productId: product._id,
            product: {
                _id: product._id,
                title: product.title,
                imageUrl: product.imageUrl,
                price: product.price,
                discountedPrice: product.discountedPrice,
                brand: product.brand,
            },
            size,
            quantity,
            // Mimic cart item structure for CartItem component
            price: product.price,
            discountedPrice: product.discountedPrice,
        });
    }

    saveGuestCart(cart);
    return cart;
};

export const removeFromGuestCart = (productId, size) => {
    const cart = getGuestCart().filter(
        (i) => !(i.productId === productId && i.size === size)
    );
    saveGuestCart(cart);
    return cart;
};

export const updateGuestCartItem = (productId, size, quantity) => {
    const cart = getGuestCart();
    const idx = cart.findIndex(
        (i) => i.productId === productId && i.size === size
    );
    if (idx >= 0) {
        if (quantity <= 0) {
            cart.splice(idx, 1);
        } else {
            cart[idx].quantity = quantity;
        }
    }
    saveGuestCart(cart);
    return cart;
};

export const clearGuestCart = () => {
    localStorage.removeItem(GUEST_CART_KEY);
};

export const getGuestCartTotals = (cart) => {
    const totalItem = cart.reduce((sum, i) => sum + i.quantity, 0);
    const totalPrice = cart.reduce(
        (sum, i) => sum + i.price * i.quantity,
        0
    );
    const totalDiscountedPrice = cart.reduce(
        (sum, i) => sum + i.discountedPrice * i.quantity,
        0
    );
    const discounte = totalPrice - totalDiscountedPrice;
    return { totalItem, totalPrice, totalDiscountedPrice, discounte };
};
